import { useMemo } from 'react';

import { usePlayerStoreApi } from '../store/playerStore';

export function usePlayerActions(playerId?: string) {
  const store = usePlayerStoreApi();

  return useMemo(
    () => ({
      play: () => store.play(playerId),
      pause: () => store.pause(playerId),
      toggle: () => store.toggle(playerId),
      playOrPause: (playState?: boolean) =>
        store.playOrPause(playState, playerId),
      setFrame: (frame: number) => store.setFrame(frame, playerId),
      frameJump: (numFrames: number) => store.frameJump(numFrames, playerId),
      setActiveActor: (nextActorId: string | null) =>
        store.setActiveActor(nextActorId),
      registerActor: (actorId: string) => store.registerActor(actorId),
      unregisterActor: (actorId: string) => store.unregisterActor(actorId),
    }),
    [playerId, store],
  );
}
